import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="site-footer"
    className="bg-ink-900 text-white relative overflow-hidden grain"
  >
    <div className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="eyebrow text-champagne">Del Cid Productions · Legal Video</div>
        <h3 className="font-display text-3xl lg:text-4xl mt-4 leading-tight">
          On the record.
          <br />
          On time. On every screen.
        </h3>
        <p className="mt-4 text-xs font-mono tracking-[0.18em] uppercase text-champagne/80">
          California Notary · Certified Legal Videographers
        </p>
      </div>

      <div className="md:col-span-3">
        <div className="eyebrow text-champagne mb-4">Coordination</div>
        <p className="text-sm text-white/70 leading-relaxed">
          <a href="mailto:booking@delcidproductions.com" data-testid="footer-email" className="hover:text-champagne">
            booking@delcidproductions.com
          </a>
          <br />
          <a href="tel:+14242251267" data-testid="footer-phone" className="font-mono text-xs tracking-[0.15em] hover:text-champagne">
            +1 (424) 225 — 1267
          </a>
          <br />
          Mon–Fri · 7:00–19:00 PT
        </p>
      </div>

      <div className="md:col-span-4">
        <div className="eyebrow text-champagne mb-4">Headquarters</div>
        <p className="text-sm text-white/70 leading-relaxed" data-testid="footer-address">
          Hawthorne, California
          <br />
          Serving CA statewide · remote nationwide
        </p>
      </div>
    </div>

    <div className="border-t border-white/10 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/40">
        © {new Date().getFullYear()} Del Cid Productions
      </div>
      <div className="flex items-center gap-6 text-xs text-white/50">
        <span>CA Notary Public</span>
        <span className="w-1 h-1 bg-champagne rounded-full" />
        <span>Certified Videographers</span>
        <span className="w-1 h-1 bg-champagne rounded-full" />
        <Link to="/book" data-testid="footer-book-link" className="hover:text-champagne">Book →</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
